import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { isFunction } from '@polkadot/util';
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
import { calcVotes, getStatus, parseImage } from "./util.mjs";

function votesPrev(api, referendumId) {
  return api.query.democracy.votersFor(referendumId).pipe(switchMap(function (votersFor) {
    return combineLatest([of(votersFor), votersFor.length ? api.query.democracy.voteOf.multi(votersFor.map(function (accountId) {
      return [referendumId, accountId];
    })) : of([]), api.derive.balances.votingBalances(votersFor)]);
  }), map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        votersFor = _ref2[0],
        votes = _ref2[1],
        balances = _ref2[2];

    return votersFor.map(function (accountId, index) {
      return {
        accountId: accountId,
        balance: balances[index].votingBalance || api.registry.createType('Balance'),
        isDelegating: false,
        vote: votes[index] || api.registry.createType('Vote')
      };
    });
  }));
}

function extractVotes(mapped, referendumId) {
  return mapped.filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        voting = _ref4[1];

    return voting.isDirect;
  }).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        accountId = _ref6[0],
        voting = _ref6[1];

    return [accountId, voting.asDirect.votes.filter(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          idx = _ref8[0];

      return idx.eq(referendumId);
    })];
  }).filter(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        directVotes = _ref10[1];

    return !!directVotes.length;
  }).reduce(function (result, _ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
        accountId = _ref12[0],
        votes = _ref12[1];

    return (// FIXME We are ignoring split votes
      votes.reduce(function (result, _ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
            vote = _ref14[1];

        if (vote.isStandard) {
          result.push(_objectSpread({
            accountId: accountId,
            isDelegating: false
          }, vote.asStandard));
        }

        return result;
      }, result)
    );
  }, []);
}

function votesCurr(api, referendumId) {
  return api.query.democracy.votingOf.entries().pipe(map(function (allVoting) {
    var mapped = allVoting.map(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
          _ref16$0$args = _slicedToArray(_ref16[0].args, 1),
          accountId = _ref16$0$args[0],
          voting = _ref16[1];

      return [accountId, voting];
    });
    var votes = extractVotes(mapped, referendumId);
    var delegations = mapped.filter(function (_ref17) {
      var _ref18 = _slicedToArray(_ref17, 2),
          voting = _ref18[1];

      return voting.isDelegating;
    }).map(function (_ref19) {
      var _ref20 = _slicedToArray(_ref19, 2),
          accountId = _ref20[0],
          voting = _ref20[1];

      return [accountId, voting.asDelegating];
    }); // add delegations

    delegations.forEach(function (_ref21) {
      var _ref22 = _slicedToArray(_ref21, 2),
          accountId = _ref22[0],
          _ref22$ = _ref22[1],
          balance = _ref22$.balance,
          conviction = _ref22$.conviction,
          target = _ref22$.target;

      // Are we delegating to a delegator
      var toDelegator = delegations.find(function (_ref23) {
        var _ref24 = _slicedToArray(_ref23, 1),
            accountId = _ref24[0];

        return accountId.eq(target);
      });
      var to = votes.find(function (_ref25) {
        var accountId = _ref25.accountId;
        return accountId.eq(toDelegator ? toDelegator[0] : target);
      }); // this delegation has a target

      if (to) {
        votes.push({
          accountId: accountId,
          balance: balance,
          isDelegating: true,
          vote: api.registry.createType('Vote', {
            aye: to.vote.isAye,
            conviction: conviction
          })
        });
      }
    });
    return votes;
  }));
}

export function _referendumVotes(instanceId, api) {
  return memo(instanceId, function (referendum) {
    return combineLatest([api.derive.democracy.sqrtElectorate(), isFunction(api.query.democracy.votingOf) ? votesCurr(api, referendum.index) : votesPrev(api, referendum.index)]).pipe(map(function (_ref26) {
      var _ref27 = _slicedToArray(_ref26, 2),
          sqrtElectorate = _ref27[0],
          votes = _ref27[1];

      return calcVotes(sqrtElectorate, referendum, votes);
    }));
  });
}
export function _referendumsVotes(instanceId, api) {
  return memo(instanceId, function (referendums) {
    return referendums.length ? combineLatest(referendums.map(function (referendum) {
      return api.derive.democracy._referendumVotes(referendum);
    })) : of([]);
  });
}
export function _referendumInfo(instanceId, api) {
  return memo(instanceId, function (index, info) {
    var status = getStatus(info);
    return status ? api.query.democracy.preimages(status.proposalHash).pipe(map(function (preimage) {
      return {
        image: parseImage(api, preimage),
        imageHash: status.proposalHash,
        index: api.registry.createType('ReferendumIndex', index),
        status: status
      };
    })) : of(null);
  });
}
export function referendumsInfo(instanceId, api) {
  return memo(instanceId, function (ids) {
    return ids.length ? api.query.democracy.referendumInfoOf.multi(ids).pipe(switchMap(function (infos) {
      return combineLatest(ids.map(function (id, index) {
        return api.derive.democracy._referendumInfo(id, infos[index]);
      }));
    }), map(function (infos) {
      return infos.filter(function (referendum) {
        return !!referendum;
      });
    })) : of([]);
  });
}